<template>
  <common-confirm v-model="value"
                  type="custom"
                  :width="popupInfo && popupInfo?.modalWidth ? popupInfo?.modalWidth : '70%'"
                  :z-index="999999">
    <!--隐私-->
    <div v-if="popupInfo?.type === 2" class="privacy-modal">
      <div class="privacy-modal-header">
        <div class="header-title" v-html="popupInfo?.title"></div>
      </div>
      <div class="privacy-modal-content">
        皇家加勒比集团始终重视并致力于保护您的个人信息，为帮助您更清晰、方便地了解关于个人信息收集场景、处理方式的更多详细信息，{{popupInfo?.changeNote}}您可以点击<a :href="privacyLink" class="privacy-link">《隐私政策》
      </a>以完整阅读更新后的内容，当您点击【同意并继续】时，即表示您已理解并同意该条款内容。
      </div>
      <div class="privacy-modal-footer">
        <div class="btn btn-cancel" @click="cancelAgree">退出</div>
        <div class="btn" @click="submitAgree">同意并继续</div>
      </div>
    </div>
    <!--游享荟-->
    <div v-else-if="popupInfo?.type === 3" class="privacy-modal">
      <div class="privacy-modal-header type-3">
        <div class="header-title" v-html="popupInfo?.title"></div>
        <div class="header-close" @click="closeAgree">
          <img class="icon" :src="`${imgUrl}/global/icons/iconCloseWhite.png`" alt="" />
        </div>
      </div>
      <div class="privacy-modal-content type-3">
        为持续完善会员服务机制，我们更新了《皇家游享荟项目细则》，{{popupInfo?.changeNote}}您可点击<a :href="rewardPrivacyLink" class="privacy-link">链接</a>了解具体内容，并仔细阅读。您也可咨询客服电话（4008207705）或在线客服。
      </div>
    </div>
  </common-confirm>
</template>

<script>
const CommonConfirm = () => import("@/components/Common/CommonConfirm");
export default {
  name: "PrivacyModal",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userAgreementInfo: {
      type: Object,
      default: null
    }
  },
  watch: {
    value: {
      handler(val) {
        if(val) {
          const {type, changeNote} = this.userAgreementInfo;
          // 1:用户协议 2:隐私政策 3:皇家游享荟项目细则
          const popupInfoVal = {
            2: {
              title: "《隐私政策》<br/>更新提醒",
              modalWidth: 650,
              changeNote: changeNote,
              type: type
            },
            3: {
              title: "温馨提示",
              modalWidth: 560,
              changeNote: changeNote,
              type: type
            }
          }
          this.popupInfo = popupInfoVal[type];
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      privacyLink: "/Rccl.UserCenter/Privacy",
      userAgreementLink: "/wz_index_law/index",
      rewardPrivacyLink: process.env.VUE_APP_BASE_URL + "/Rccl.UserCenter/RewardRule",
      popupInfo: null
    }
  },
  components: {
    CommonConfirm
  },
  methods: {
    cancelAgree() {
      this.$emit('submit',{ isAgree: false, type: this.userAgreementInfo.type });
    },
    submitAgree() {
      this.$emit('submit',{ isAgree: true, type: this.userAgreementInfo.type });
    },
    closeAgree() {
      this.submitAgree();
    }
  }
}
</script>

<style scoped lang="less">
.privacy-modal-header {
  position: relative;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  & .header-title {
    padding-top: 20px;
    padding-bottom: 15px;
    color: #FEBC10;
  }
  & .header-close {
    position: absolute;
    top: 4px;
    right: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 20px;
    border-radius: 20px;
    background-color: rgba(136,136,136,0.5);
    & .icon {
      height: 12px;
      width: 12px;
    }
  }
  &.type-3 {
    & .header-title {
      border-bottom: 1px solid #eee;
      box-sizing: border-box;
      font-size: 16px;
      text-align: center;
      padding: 8px 0 6px;
      margin: 0 15px;
      min-height: 22px;
      line-height: 22px;
      color: #FCC000;
    }
  }
}
.privacy-modal-content {
  padding: 0 15px;
  font-size: 12px;
  line-height: 18px;
  color: #333;
  text-indent: 2em;
  word-break: break-all;
  max-height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
  &.type-3 {
    text-indent: 0;
    font-size: 14px;
    line-height: 20px;
    padding: 6px 15px 15px;
  }
}
.privacy-modal-footer {
  padding: 25px 0 0;
  text-align: center;
  display: flex;
  & .btn {
    flex: 1;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    color: #333;
    text-align: center;
    background: -webkit-gradient(linear, left top, right top, from(#FEBC10), to(#FAD961));
    background: -webkit-linear-gradient(left, #FEBC10, #FAD961);
    background: -moz-linear-gradient(left, #FEBC10, #FAD961);
    background: -o-linear-gradient(left, #FEBC10, #FAD961);
    background: linear-gradient(to right, #FEBC10, #FAD961);
    border-bottom-right-radius: 5px;
    &:active {
      background: linear-gradient(225deg,rgba(255, 219, 23, 1) 0%, rgba(252, 191, 0, 1) 50%);
    }
    &.btn-cancel {
      background: #f7f7f7;
      border-bottom-left-radius: 5px;
      &:active {
        background: #f0f0f0;
      }
    }
  }
}
</style>
